import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthGuard } from "../auth.guard";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { AuthenticationService } from "../authentication.service";
import { SignatureService } from "../../../signature/signature.service";

interface LoginResponse {
  Authentication: string;
  Email: string;
}

@Component({
  moduleId: module.id,

  selector: "app-admin",
  templateUrl: "./admin.component.html",
  styleUrls: ["./admin.component.css"],
})
export class AdminComponent implements OnInit {
  public guid: string;
  public checkbox: boolean;
  public loadingEmail: boolean = false;
  public loadingCodigo: boolean = false;
  public model: any = {};
  public displayCodigo: boolean = false;
  public displayEmail: boolean = false;
  public loading = false;
  public error = "";
  public emailEnvio: any;
  public errorCodigo = "";
  public errorEmail = "";
  public fundoImg: SafeUrl;

  constructor(
    private router: Router,
    private service: AuthenticationService,
    private sanitizer: DomSanitizer,
    private signatureService: SignatureService
  ) {}

  ngOnInit() {
    const auth = new AuthGuard(this.router);
    if (auth.getLogado()) {
      this.router.navigateByUrl("/");
    }

    // Imagem é requisitada logo ao carregar; o interceptor faz GET /tempo antes e adiciona a assinatura
    this.service
      .getImagem(`/alterar_imagem/getImagem?tipoImagem=1`)
      .subscribe((response) => {
        const base64Image = response.image;
        this.fundoImg = `data:image/png;base64,${base64Image}`;
      });
  }

  async logon() {
    this.loading = true;
    this.error = "";
    this.guid = localStorage.getItem("Guid");

    this.service
      .login(this.model.username, this.model.password, this.guid)
      .subscribe({
        next: (v: LoginResponse) => {
          if (v.Authentication == "Ok") {
            this.emailEnvio = v.Email;
            this.displayCodigo = true;
            this.loading = false;
          } else {
            this.tratarLoginSucesso(v, this.model.username);
          }
        },
        error: (e) => {
          this.tratarLoginErro(e);
        },
      });
  }

  tratarLoginSucesso(response, username: string) {
    this.displayCodigo = false;
    this.loading = false;
    sessionStorage.clear();
    const retorno = response;

    if (retorno.Authentication) {
      let newToken = retorno.Authentication.replace(/"'"/g, "");

      sessionStorage.removeItem("currentUser");
      sessionStorage.setItem(
        "currentUser",
        JSON.stringify({ username: username, token: retorno.Authentication })
      );
      sessionStorage.setItem("token", newToken);

      this.signatureService.sync().subscribe(() => {
        this.router.navigateByUrl("/");
      });
      return;
    }
    this.tratarLoginErro(response);
  }

  tratarLoginErro(erro) {
    this.loading = false;
    if (erro.status === 403) {
      this.error = "Usuário ou senha incorreto";
    } else if (erro.status === 408) {
      this.error = "Senha Expirado. Por favor, crie uma nova";
    } else if (erro.status === 401) {
      this.error = "Usuário inativo";
    } else {
      this.error = "Por favor, tente mais tarde";
    }
  }

  tratarCodigoErro(erro) {
    this.loading = false;

    this.errorCodigo =
      erro.status === 403 ? "Código inválido" : "Código expirado";

    if (erro.status === 403) {
      this.errorEmail = "Usuário inválido ou inexistente";
    } else {
      this.displayEmail = false;
      this.model.user = "";
      this.errorEmail = "";
    }
  }

  enviaCodigo() {
    this.loading = true;
    this.errorCodigo = "";

    this.validarCodigo();

    if (this.checkbox) {
      setTimeout(() => {
        this.inserirGuidStorage();
      }, 1000);
    }
  }

  cancelarCodigo() {
    this.errorCodigo = "";
    this.errorEmail = "";
    this.model.codigo = "";
    this.model.user = "";
    this.displayCodigo = false;
    this.displayEmail = false;
  }

  reenviarCodigo() {
    this.loading = true;
    this.loadingCodigo = true;
    this.guid = localStorage.getItem("Guid");
    this.service
      .login(this.model.username, this.model.password, this.guid)
      .subscribe({
        next: (v) => {
          this.loading = false;
          this.loadingCodigo = false;
        },
        error: (e) => {},
      });
  }

  enviarEmail() {
    this.loadingEmail = true;
    this.service
      .redefinirSenha(this.model.user)
      .catch((erro) => this.tratarCodigoErro(erro));
  }

  inserirGuidStorage() {
    this.service
      .pegarGuid(`/admin/adicionarGUID?username=${this.model.username}`)
      .subscribe({
        next: (res: any) => {
          localStorage.setItem("Guid", res.GuidConfianca);
        },
      });
  }

  validarCodigo() {
    this.service
      .validarCodigo(
        this.model.username,
        this.model.password,
        this.model.codigo,
        this.checkbox
      )
      .then((response) =>
        this.tratarLoginSucesso(response, this.model.username)
      )
      .catch((erro) => this.tratarCodigoErro(erro));
  }
}
